import axios from "axios";

const DELAYS = [800, 2000];
const sleep = (ms) => new Promise(r => setTimeout(r, ms));

// GET baca-saja dengan timeout + retry terbatas HANYA untuk gangguan sementara (jaringan/timeout/5xx/429).
export const isTransient = (e) => {
  const st = e?.response?.status;
  return !st || st >= 500 || st === 429;
};

export async function getWithRetry(url, { params, timeout = 15000 } = {}) {
  let last;
  for (let i = 0; i <= DELAYS.length; i++) {
    try {
      return await axios.get(url, { params, timeout, withCredentials: true });
    } catch (e) {
      last = e;
      if (!isTransient(e) || i === DELAYS.length) break;
      await sleep(DELAYS[i]);
    }
  }
  throw last;
}

// Pesan yang membedakan sesi habis, akses ditolak, server bermasalah, dan koneksi putus.
export function describeLoadError(e) {
  const st = e?.response?.status;
  const detail = typeof e?.response?.data?.detail === "string" ? e.response.data.detail : "";
  if (st === 401) return { kind: "auth", text: detail || "Sesi login berakhir. Silakan keluar lalu masuk kembali." };
  if (st === 403) return { kind: "forbidden", text: detail || "Akun ini tidak memiliki akses." };
  if (st && st >= 500) return { kind: "server", text: `Server sedang bermasalah (kode ${st}). Coba lagi sebentar.` };
  if (st) return { kind: "client", text: detail || `Permintaan ditolak (kode ${st}).` };
  if (e?.code === "ECONNABORTED") return { kind: "network", text: "Server terlalu lama merespons. Periksa koneksi lalu coba lagi." };
  return { kind: "network", text: "Koneksi ke server terputus. Periksa internet lalu coba lagi." };
}
